module.exports = __webpack_public_path__ + "img/b_1.4a9c170d.jpg";